export const STRINGS = {
  clearButtonAriaLabel: label => `Clear ${label}`,
  clearButtonLabel: label => `Clear ${label}`,
  searchText: "Search ",
  defaultRequiredErrorMessage: label => `Enter ${label}`
};